import { Component, signal, computed } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Header } from './shared/components/layout/header/header.component';
import { Sidebar } from './shared/components/layout/sidebar/sidebar.component';
import { AuthService } from './core/services/auth.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Header, Sidebar],
  templateUrl: './app.component.html',
  styleUrl: './app.scss'
})
export class App {
  sidebarOpen = signal(false);
  sidebarCollapsed = signal(false);

  // Check if user is authenticated
  isAuthenticated = computed(() => this.authService.user() !== null);

  constructor(private authService: AuthService) {}

  toggleSidebar(): void {
    this.sidebarOpen.update(value => !value);
  }

  onSidebarCollapsedChange(collapsed: boolean): void {
    this.sidebarCollapsed.set(collapsed);
  }
}
